module.exports = __webpack_public_path__ + "assets/d1ad94b7f90aab13d621eae30561cb3f.png";